// dna_frontend/src/pages/LSDongNoi.js
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import './LietSiManagement.css'; 

const InfoCard = ({ label, value }) => (
    <div style={{ marginBottom: '8px' }}>
        <span style={{ fontWeight: 'bold', color: '#555', fontSize: '0.9em' }}>{label}:</span>
        <div style={{ padding: '5px 8px', background: '#fff', border: '1px solid #ddd', borderRadius: '4px', marginTop: '2px', minHeight: '20px', color: '#333' }}>
            {value || '-'}
        </div>
    </div>
);

const ModalRaSoat = ({ item, onClose, onSave }) => {
    const [hasLS, setHasLS] = useState(null); 
    const [formData, setFormData] = useState({
        ho_ten_ls_chuan: item.ho_ten_ls_upload,
        ngay_sinh_ls_chuan: item.nam_sinh_ls_upload || '',
        que_quan_ls_chuan: item.que_quan_upload || '',
        so_bang_tqgc: '',
        ghi_chu: ''
    });
    const [listMe, setListMe] = useState([]);
    const [listCha, setListCha] = useState([]);
    const [activeTab, setActiveTab] = useState('info'); 

    useEffect(() => {
        api.get(`/ls-dong-noi/detail/${item.id}`).then(res => {
            const { ls, dong_me, dong_cha } = res.data;
            if (ls.ket_qua_ra_soat === 'co_ls') {
                setHasLS(true);
                setFormData({
                    ho_ten_ls_chuan: ls.ho_ten_ls_chuan,
                    ngay_sinh_ls_chuan: ls.ngay_sinh_ls_chuan,
                    que_quan_ls_chuan: ls.que_quan_ls_chuan,
                    so_bang_tqgc: ls.so_bang_tqgc,
                    ghi_chu: ls.ghi_chu 
                });
                setListMe(dong_me);
                setListCha(dong_cha);
            } else if (ls.ket_qua_ra_soat === 'khong_co_ls' || ls.ket_qua_ra_soat === 'da_bao_khong_co') {
                setHasLS(false);
            }
        });
    }, [item.id]);

    // (*** MỚI: Khởi tạo có da_thu_mau: false ***)
    const addRel = (type) => {
        const newItem = { ho_ten: '', noi_thuong_tru: '', cccd: '', moi_quan_he: '', da_thu_mau: false };
        if (type === 'me') setListMe([...listMe, newItem]); else setListCha([...listCha, newItem]);
    };

    const updateRel = (type, idx, field, val) => {
        const list = type === 'me' ? [...listMe] : [...listCha];
        list[idx][field] = val;
        if (type === 'me') setListMe(list); else setListCha(list);
    };

    const removeRel = (type, idx) => {
        if (type === 'me') setListMe(listMe.filter((_, i) => i !== idx)); else setListCha(listCha.filter((_, i) => i !== idx));
    };

const validate = () => {
        if (hasLS === null) return alert("Vui lòng xác nhận CÓ hay KHÔNG CÓ liệt sĩ.");
        if (hasLS === false) return true; 

        if (!formData.ho_ten_ls_chuan) return alert("Vui lòng nhập Họ tên LS trên bằng TQGC");
        
        if (!formData.so_bang_tqgc || formData.so_bang_tqgc.trim() === '') {
            return alert("BẮT BUỘC phải nhập 'Số bằng Tổ quốc ghi công'.");
        }

        // Hàm kiểm tra số lượng tối đa của từng mối quan hệ
        const checkQuantityLimits = (list, label) => {
            const counts = {};
            
            // 1. Đếm số lượng từng loại quan hệ
            list.forEach(r => {
                if (r.moi_quan_he) {
                    counts[r.moi_quan_he] = (counts[r.moi_quan_he] || 0) + 1;
                }
            });

            // 2. Kiểm tra theo quy tắc
            for (const [rel, count] of Object.entries(counts)) {
                // Nhóm ĐẶC BIỆT: Chỉ được tối đa 1 người
                if (['Cha đẻ', 'Bố đẻ', 'Mẹ đẻ', 'Bà ngoại'].includes(rel)) {
                    if (count > 1) {
                        return `Lỗi tại ${label}: Quan hệ "${rel}" chỉ được phép nhập duy nhất 1 người.`;
                    }
                } 
                // Nhóm CÒN LẠI: Chỉ được tối đa 2 người
                else {
                    if (count > 2) {
                        return `Lỗi tại ${label}: Quan hệ "${rel}" chỉ được phép nhập tối đa 2 người.`;
                    }
                }
            }
            return null; // Không có lỗi
        };

        // Kiểm tra giới hạn số lượng
        const errLimitMe = checkQuantityLimits(listMe, 'Dòng Mẹ');
        if (errLimitMe) return alert(errLimitMe);

        const errLimitCha = checkQuantityLimits(listCha, 'Dòng Cha');
        if (errLimitCha) return alert(errLimitCha);

        // Kiểm tra điền đủ thông tin từng dòng
        const validateList = (list, name) => {
            for (let i = 0; i < list.length; i++) {
                const r = list[i];
                if (!r.ho_ten) return `Dòng ${i+1} bên ${name}: Thiếu họ tên.`;
                if (!r.cccd || !/^\d{12}$/.test(r.cccd.trim())) return `Dòng ${i+1} bên ${name}: CCCD bắt buộc phải đủ 12 chữ số.`;
                if (!r.moi_quan_he) return `Dòng ${i+1} bên ${name}: Thiếu mối quan hệ.`;
            }
            return null;
        };

        const errMe = validateList(listMe, "Dòng Mẹ"); if (errMe) return alert(errMe);
        const errCha = validateList(listCha, "Dòng Cha"); if (errCha) return alert(errCha);

        return true;
    };
    const submit = async (isFinal) => {
        const check = validate();
        if (check !== true) return; 
        
        let confirmMsg = "Sau khi gửi bạn sẽ KHÔNG THỂ SỬA.";
        if (hasLS === false && !item.xa_id_giao) {
            confirmMsg = "Xác nhận báo 'KHÔNG CÓ' lên hệ thống? (Các xã khác vẫn có thể nhận rà soát)";
        }
        
        if (isFinal && !window.confirm(confirmMsg + " Tiếp tục?")) return;
        
        try {
            await api.post(`/ls-dong-noi/report/${item.id}`, {
                ket_qua_ra_soat: hasLS ? 'co_ls' : 'khong_co_ls',
                is_final_submit: isFinal,
                ...formData,
                list_me: listMe,
                list_cha: listCha
            });
            alert("Thành công!"); onSave(); onClose();
        } catch (e) { alert("Lỗi: " + e.response?.data?.message); }
    };

    const backdropStyle = {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.6)', 
        display: 'flex', justifyContent: 'center', alignItems: 'center', 
        zIndex: 9999 
    };

    return (
        <div style={backdropStyle}>
            <div className="modal-content" style={{ width: '95vw', maxWidth: '1200px', height: '90vh', padding: '0', display: 'flex', flexDirection: 'column', background: 'white', borderRadius: '8px', overflow: 'hidden' }}>
                <div style={{ padding: '15px 20px', borderBottom: '1px solid #ddd', background: '#f8f9fa', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0, color: '#2c3e50' }}>Rà soát: {item.ho_ten_ls_upload}</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '2rem', cursor: 'pointer', lineHeight: '1' }}>&times;</button>
                </div>

                <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                    <div style={{ width: '30%', background: '#f0f4f8', padding: '20px', overflowY: 'auto', borderRight: '1px solid #ddd' }}>
                        <div style={{textTransform: 'uppercase', color: '#666', fontSize: '0.8rem', fontWeight: 'bold', marginBottom: '10px'}}>Thông tin từ Admin</div>
                        <div style={{ display: 'grid', gap: '5px' }}>
                            <InfoCard label="Họ tên LS" value={item.ho_ten_ls_upload} />
                            <InfoCard label="Năm sinh" value={item.nam_sinh_ls_upload} />
                            <InfoCard label="Quê quán" value={item.que_quan_upload} />
                            <InfoCard label="Đơn vị" value={item.don_vi_upload} />
                            <InfoCard label="Ngày hy sinh" value={item.ngay_hy_sinh_upload} />
                            <InfoCard label="Nơi an táng" value={item.noi_an_tang_upload} />
                            <div style={{ borderTop: '1px dashed #ccc', margin: '15px 0' }}></div>
                            <InfoCard label="Thân nhân (Gốc)" value={item.ten_than_nhan_upload} />
                            <InfoCard label="SĐT Thân nhân" value={item.sdt_than_nhan_upload} />
                        </div>
                    </div>

                    <div style={{ width: '70%', padding: '20px', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
                        <div style={{textTransform: 'uppercase', color: '#2e7d32', fontSize: '0.8rem', fontWeight: 'bold', marginBottom: '10px'}}>Kết quả rà soát tại Xã</div>
                        <div style={{ background: '#fff9db', padding: '15px', borderRadius: '6px', marginBottom: '20px', border: '1px solid #ffe066', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <span style={{fontWeight: 'bold'}}>Xác nhận thông tin:</span>
                            <div style={{ display: 'flex', gap: '30px' }}>
                                <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                    <input type="radio" checked={hasLS === true} onChange={() => setHasLS(true)} style={{ width: '20px', height: '20px', marginRight: '8px' }} />
                                    <span style={{ fontWeight: 'bold', color: 'green' }}>CÓ LS TẠI ĐỊA BÀN</span>
                                </label>
                                <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                    <input type="radio" checked={hasLS === false} onChange={() => setHasLS(false)} style={{ width: '20px', height: '20px', marginRight: '8px' }} />
                                    <span style={{ fontWeight: 'bold', color: 'red' }}>KHÔNG CÓ LS</span>
                                </label>
                            </div>
                        </div>

                        {hasLS === true && (
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                <div className="tabs">
                                    <button className={activeTab==='info'?'active':''} onClick={()=>setActiveTab('info')}>1. Thông tin Bằng TQGC</button>
                                    <button className={activeTab==='me'?'active':''} onClick={()=>setActiveTab('me')}>2. Thân nhân Dòng Mẹ</button>
                                    <button className={activeTab==='cha'?'active':''} onClick={()=>setActiveTab('cha')}>3. Thân nhân Dòng Cha</button>
                                </div>

                                <div className="tab-content" style={{ border: '1px solid #ccc', borderTop: 'none', padding: '20px', flex: 1, overflowY: 'auto', background: '#fff' }}>
                                    {activeTab === 'info' && (
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                            <div><label>Họ tên LS (Chuẩn) (*):</label><input className="form-control" value={formData.ho_ten_ls_chuan} onChange={e=>setFormData({...formData, ho_ten_ls_chuan: e.target.value})} /></div>
                                            <div><label>Ngày sinh:</label><input className="form-control" value={formData.ngay_sinh_ls_chuan} onChange={e=>setFormData({...formData, ngay_sinh_ls_chuan: e.target.value})} /></div>
                                            <div style={{ gridColumn: 'span 2' }}><label>Quê quán:</label><input className="form-control" value={formData.que_quan_ls_chuan} onChange={e=>setFormData({...formData, que_quan_ls_chuan: e.target.value})} /></div>
                                            <div><label>Số Bằng TQGC (*):</label><input className="form-control" value={formData.so_bang_tqgc} onChange={e=>setFormData({...formData, so_bang_tqgc: e.target.value})} placeholder="Bắt buộc nhập" style={{border: '1px solid orange'}} /></div>
                                            <div style={{ gridColumn: 'span 2' }}><label>Ghi chú:</label><textarea className="form-control" rows="3" value={formData.ghi_chu} onChange={e=>setFormData({...formData, ghi_chu: e.target.value})} placeholder="Nhập ghi chú nếu có..." /></div>
                                        </div>
                                    )}

                                    {(activeTab === 'me' || activeTab === 'cha') && (
                                        <div>
                                            <div style={{display:'flex', justifyContent:'space-between', marginBottom: 10}}>
                                                <span style={{fontStyle:'italic', color:'#666'}}>Nhập danh sách thân nhân thuộc {activeTab==='me'?'Dòng Mẹ':'Dòng Cha'}:</span>
                                                <button className="btn-secondary" onClick={()=>addRel(activeTab)} style={{padding: '5px 10px'}}>+ Thêm dòng</button>
                                            </div>
                                            
                                            <table className="crud-table" style={{ fontSize: '0.9em' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{width: '25%'}}>Họ tên (*)</th>
                                                        <th style={{width: '25%'}}>Nơi trú</th>
                                                        <th style={{width: '15%'}}>CCCD (12 số) (*)</th>
                                                        <th style={{width: '15%'}}>Quan hệ (*)</th>
                                                        <th style={{width: '10%'}}>Đã thu mẫu</th>
                                                        <th style={{width: '5%'}}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(activeTab === 'me' ? listMe : listCha).map((r, i) => (
                                                        <tr key={i}>
                                                            <td><input value={r.ho_ten} onChange={e=>updateRel(activeTab,i,'ho_ten',e.target.value)} style={{width: '100%'}} /></td>
                                                            <td><input value={r.noi_thuong_tru} onChange={e=>updateRel(activeTab,i,'noi_thuong_tru',e.target.value)} style={{width: '100%'}} /></td>
                                                            <td><input value={r.cccd} onChange={e=>updateRel(activeTab,i,'cccd',e.target.value)} maxLength={12} style={{width: '100%'}} placeholder="Đủ 12 số" /></td>
                                                            <td>
                                                                <select value={r.moi_quan_he} onChange={e=>updateRel(activeTab,i,'moi_quan_he',e.target.value)} style={{width: '100%'}}>
                                                                    <option value="">--Chọn--</option>
                                                                    {activeTab==='me' 
                                                                        ? ['Mẹ đẻ','Bà ngoại','Anh chị em cùng mẹ đẻ','Anh chị em cùng mẹ đẻ với mẹ đẻ','Con của chị gái, em gái mẹ đẻ','Con của chị gái, em gái'].map(o=><option key={o} value={o}>{o}</option>)
                                                                        : ['Cha đẻ','Con đẻ','Anh chị em cùng cha đẻ','Cháu nội/ngoại ruột','Con ruột của anh/chị/em ruột','Cô chú bác ruột (anh chị em ruột với bố đẻ)'].map(o=><option key={o} value={o}>{o}</option>)
                                                                    }
                                                                </select>
                                                            </td>
                                                            {/* (*** MỚI: Checkbox Thu Mẫu ***) */}
                                                            <td style={{textAlign: 'center'}}>
                                                                <input type="checkbox" checked={r.da_thu_mau || false} onChange={e=>updateRel(activeTab,i,'da_thu_mau',e.target.checked)} style={{width:'18px', height:'18px'}} />
                                                            </td>
                                                            <td style={{textAlign: 'center'}}><button onClick={()=>removeRel(activeTab,i)} style={{color:'red', border:'none', background:'none', cursor:'pointer', fontWeight:'bold'}}>X</button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div style={{ padding: '15px 20px', borderTop: '1px solid #ddd', background: '#f8f9fa', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button onClick={onClose} className="btn-secondary">Đóng</button>
                    {hasLS === false && <button onClick={()=>submit(true)} className="btn-delete">Xác nhận KHÔNG CÓ (Gửi luôn)</button>}
                    {hasLS === true && (
                        <>
                            <button onClick={()=>submit(false)} className="btn-edit" style={{marginRight: 'auto'}}>Lưu nháp (Chưa gửi)</button>
                            <button onClick={()=>submit(true)} className="btn-primary" style={{padding: '10px 25px', fontSize: '1.1em'}}>HOÀN THÀNH & GỬI</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const LSDongNoi = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]); 
    const [view, setView] = useState('list'); 
    const [file, setFile] = useState(null);
    const [modalItem, setModalItem] = useState(null);

    const fetchData = async () => {
        try {
            const res = await api.get('/ls-dong-noi/list');
            setData(res.data);
            if(user.role === 'admin' || user.role === 'xa') {
                const relRes = await api.get('/ls-dong-noi/relatives');
                setViewData(relRes.data);
            }
        } catch (e) { console.error(e); }
    };

    useEffect(() => { fetchData(); }, [user.role]);

    const handleUpload = async () => {
        if(!file) return alert("Chưa chọn file");
        const formData = new FormData();
        formData.append('file', file);
        try {
            await api.post('/ls-dong-noi/upload', formData);
            alert("Upload thành công!");
            fetchData();
        } catch (e) { alert("Lỗi upload"); }
    };

    const handleUnlock = async (id) => {
        if(window.confirm("Mở khóa hồ sơ này?")) {
            await api.put(`/ls-dong-noi/unlock/${id}`);
            fetchData();
        }
    };

    const handleExport = () => {
        let sheetData = [];
        let fileName = "";
        let merges = []; 

        if (view === 'list') {
            sheetData = data; 
            fileName = "DS_Goc_Giao.xlsx";
        } else {
            fileName = `KetQua_RaSoat_${user.role === 'xa' ? user.username : 'TongHop'}.xlsx`;

            sheetData = viewData.map(item => {
                const isFirst = item.is_first_row; 
                return {
                    'STT': isFirst ? item.stt : '',
                    'Họ tên LS': isFirst ? item.ho_ten_ls : '',
                    'Ngày sinh LS': isFirst ? item.nam_sinh_ls : '',
                    'Quê quán LS': isFirst ? item.que_quan_ls : '',
                    'Số bằng TQGC': isFirst ? item.so_bang : '',
                    
                    'Họ tên (Mẹ)': item.me_ho_ten,
                    'Nơi trú (Mẹ)': item.me_noi_tru,
                    'Số CC (Mẹ)': item.me_cccd,
                    'Quan hệ (Mẹ)': item.me_quan_he,
                    // (*** MỚI: Thêm cột Đã thu mẫu vào Excel ***)
                    'Đã thu mẫu (Mẹ)': item.me_da_thu_mau ? 'Rồi' : '',

                    'Họ tên (Cha)': item.cha_ho_ten,
                    'Nơi trú (Cha)': item.cha_noi_tru,
                    'Số CC (Cha)': item.cha_cccd,
                    'Quan hệ (Cha)': item.cha_quan_he,
                    // (*** MỚI ***)
                    'Đã thu mẫu (Cha)': item.cha_da_thu_mau ? 'Rồi' : '',

                    'Ghi chú': isFirst ? item.ghi_chu : '',
                    'Xã báo cáo': isFirst ? item.ten_xa : '',
                    
                    _temp_id: item.ls_id 
                };
            });

            if (sheetData.length > 0) {
                let startIndex = 0; 
                
                for (let i = 1; i <= sheetData.length; i++) {
                    const currentId = (i < sheetData.length) ? sheetData[i]['_temp_id'] : null;
                    const prevId = sheetData[startIndex]['_temp_id'];

                    if (currentId !== prevId) {
                        const endIndex = i - 1; 
                        
                        if (endIndex > startIndex) {
                            const startRow = startIndex + 1;
                            const endRow = endIndex + 1;

                            // (CẬP NHẬT CHỈ SỐ CỘT SAU KHI THÊM 2 CỘT MỚI)
                            // 0:STT, 1-4:LS
                            // 5-8: Me, 9: Me_ThuMau
                            // 10-13: Cha, 14: Cha_ThuMau
                            // 15: GhiChu, 16: Xa
                            // Cần merge: 0,1,2,3,4 (LS) và 15, 16 (Ghi chú, Xã)
                            [0, 1, 2, 3, 4, 15, 16].forEach(colIndex => {
                                merges.push({ s: {r: startRow, c: colIndex}, e: {r: endRow, c: colIndex} });
                            });
                        }
                        startIndex = i;
                    }
                }
            }

            sheetData.forEach(d => delete d['_temp_id']);
        }

        const ws = XLSX.utils.json_to_sheet(sheetData);
        if (merges.length > 0) {
            ws['!merges'] = merges;
        }
        
        const wscols = [
            {wch:6}, {wch:25}, {wch:12}, {wch:25}, {wch:15}, 
            {wch:20}, {wch:25}, {wch:15}, {wch:15}, {wch:10}, // Thêm cột Thu mẫu mẹ
            {wch:20}, {wch:25}, {wch:15}, {wch:15}, {wch:10}, // Thêm cột Thu mẫu cha
            {wch:20}, {wch:15} 
        ];
        ws['!cols'] = wscols;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Data");
        
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {type: 'application/octet-stream'});
        saveAs(dataBlob, fileName);
    };

    return (
        <div className="liet-si-container" style={{ padding: '20px' }}>
            <h1>Rà soát LS Dòng Nội (Chuyên đề)</h1>
            
            {user.role === 'admin' && (
                <div className="upload-section" style={{marginBottom: 20, border: '1px solid #ddd', padding: 20, background: '#f9f9f9', borderRadius: '8px'}}>
                    <h4 style={{marginTop: 0}}>Admin Upload Dữ Liệu</h4>
                    <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                        <input type="file" onChange={e=>setFile(e.target.files[0])} accept=".xlsx, .xls" />
                        <button onClick={handleUpload} className="btn-primary">Tiến hành Upload</button>
                    </div>
                </div>
            )}

            <div style={{marginTop: 20, marginBottom: 20, borderBottom: '1px solid #ccc', paddingBottom: 10}}>
                <button className={view==='list'?'active':''} onClick={()=>setView('list')}>1. Danh sách Giao (Gốc)</button>
                <button className={view==='relatives'?'active':''} onClick={()=>setView('relatives')}>2. Danh sách Tổng hợp (Xã đã nhập)</button>
                <button onClick={handleExport} style={{marginLeft: 20, background: 'green', color:'white'}}>Xuất Excel (Tab hiện tại)</button>
            </div>

            {view === 'list' && (
                <table className="crud-table">
                    <thead><tr><th>STT</th><th>Họ tên LS (Giao)</th><th>Quê quán</th><th>Xã được giao</th><th>Trạng thái</th><th>Hành động</th></tr></thead>
                    <tbody>
                        {data.map(d => (
                            <tr key={d.id} style={{background: d.ket_qua_ra_soat==='khong_co_ls'?'#ffeaea':(d.ket_qua_ra_soat==='co_ls'?'#eaffea':(d.ket_qua_ra_soat==='da_bao_khong_co'?'#fff3cd':''))}}>
                                <td>{d.stt_excel}</td>
                                <td><strong>{d.ho_ten_ls_upload}</strong></td>
                                <td>{d.que_quan_upload}</td>
                                <td>{d.ten_xa_hien_thi}</td>
                                <td>
                                    {/* Hiển thị thêm thông tin cho Admin nếu có xã báo không */}
                                    {d.ket_qua_ra_soat==='chua_ra_soat' && <span style={{color: '#999'}}>Chưa rà soát</span>}
                                    
                                    {/* Nếu là Admin và hồ sơ chưa chốt nhưng có xã báo không -> Hiện cảnh báo */}
                                    {user.role === 'admin' && d.ket_qua_ra_soat==='chua_ra_soat' && d.so_luong_bao_khong > 0 && (
                                        <div style={{fontSize: '0.85em', color: 'orange', marginTop: 4}}>
                                            (Có {d.so_luong_bao_khong} xã báo KHÔNG)
                                        </div>
                                    )}

                                    {d.ket_qua_ra_soat==='khong_co_ls' && <b style={{color:'red'}}>Không có LS</b>}
                                    {d.ket_qua_ra_soat==='da_bao_khong_co' && <b style={{color:'orange'}}>Đã báo không có</b>}
                                    {d.ket_qua_ra_soat==='co_ls' && <b style={{color:'green'}}>Có LS {d.is_locked?'(Đã gửi)': '(Đang nhập)'}</b>}
                                </td>
                                <td>
                                    {/* XÃ: Nút Rà soát */}
                                    {user.role === 'xa' && (
                                        (d.is_locked || d.ket_qua_ra_soat === 'da_bao_khong_co') ? (
                                            <span style={{color: '#666', fontStyle: 'italic'}}>
                                                {d.ket_qua_ra_soat === 'da_bao_khong_co' ? 'Đã xác nhận' : 'Đã khóa'}
                                            </span>
                                        ) : (
                                            <button className="btn-edit" onClick={()=>setModalItem(d)}>Rà soát</button>
                                        )
                                    )}

                                    {/* ADMIN: Nút Mở khóa / Reset */}
                                    {/* Hiển thị khi: Đã khóa (d.is_locked) HOẶC Có xã báo không (d.so_luong_bao_khong > 0) */}
                                    {user.role === 'admin' && (d.is_locked || d.so_luong_bao_khong > 0) && (
                                        <button 
                                            className="btn-secondary" 
                                            onClick={()=>handleUnlock(d.id)}
                                            title="Mở khóa và Reset các phản hồi 'Không có'"
                                        >
                                            {d.is_locked ? 'Mở khóa' : 'Reset báo cáo'}
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {view === 'relatives' && (
                <div style={{overflowX: 'auto'}}>
                <table className="crud-table">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>LS: Họ tên</th>
                            <th>LS: Năm sinh</th>
                            <th>LS: Quê quán</th>
                            <th>LS: Số bằng</th>
                            <th style={{background: '#e3f2fd'}}>Mẹ: Họ tên</th>
                            <th style={{background: '#e3f2fd'}}>Mẹ: Nơi trú</th>
                            <th style={{background: '#e3f2fd'}}>Mẹ: CCCD</th>
                            <th style={{background: '#e3f2fd'}}>Mẹ: Quan hệ</th>
                            <th style={{background: '#e3f2fd'}}>Đã thu mẫu</th> {/* (*** MỚI ***) */}
                            <th style={{background: '#fff3e0'}}>Cha: Họ tên</th>
                            <th style={{background: '#fff3e0'}}>Cha: Nơi trú</th>
                            <th style={{background: '#fff3e0'}}>Cha: CCCD</th>
                            <th style={{background: '#fff3e0'}}>Cha: Quan hệ</th>
                            <th style={{background: '#fff3e0'}}>Đã thu mẫu</th> {/* (*** MỚI ***) */}
                            <th>Ghi chú</th>
                            <th>Xã</th>
                        </tr>
                    </thead>
                    <tbody>
                        {viewData.map((item, i) => (
                            <tr key={i} style={{borderTop: item.is_first_row ? '2px solid #ccc' : '1px solid #eee'}}>
                                <td>{item.is_first_row ? item.stt : ''}</td>
                                <td>{item.is_first_row ? <strong>{item.ho_ten_ls}</strong> : ''}</td>
                                <td>{item.is_first_row ? item.nam_sinh_ls : ''}</td>
                                <td>{item.is_first_row ? item.que_quan_ls : ''}</td>
                                <td>{item.is_first_row ? item.so_bang : ''}</td>
                                
                                <td style={{background: '#f1f8ff'}}>{item.me_ho_ten}</td>
                                <td style={{background: '#f1f8ff'}}>{item.me_noi_tru}</td>
                                <td style={{background: '#f1f8ff'}}>{item.me_cccd}</td>
                                <td style={{background: '#f1f8ff'}}>{item.me_quan_he}</td>
                                <td style={{background: '#f1f8ff', textAlign:'center', color:'blue', fontWeight:'bold'}}>{item.me_da_thu_mau ? '✓' : ''}</td>

                                <td style={{background: '#fff8e1'}}>{item.cha_ho_ten}</td>
                                <td style={{background: '#fff8e1'}}>{item.cha_noi_tru}</td>
                                <td style={{background: '#fff8e1'}}>{item.cha_cccd}</td>
                                <td style={{background: '#fff8e1'}}>{item.cha_quan_he}</td>
                                <td style={{background: '#fff8e1', textAlign:'center', color:'blue', fontWeight:'bold'}}>{item.cha_da_thu_mau ? '✓' : ''}</td>

                                <td>{item.is_first_row ? item.ghi_chu : ''}</td>
                                <td>{item.is_first_row ? item.ten_xa : ''}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                </div>
            )}

            {modalItem && <ModalRaSoat item={modalItem} onClose={()=>setModalItem(null)} onSave={fetchData} />}
        </div>
    );
};

export default LSDongNoi;